<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    ok-text="保存"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="基地名称" prop="baseName">
          <a-input v-model="form.baseName" />
        </a-form-model-item>
        <a-form-model-item label="基地形式" prop="baseForm">
          <a-select v-model="form.baseForm">
            <a-select-option
              :value="item.text"
              v-for="item in jdlblist"
              :key="item.text"
              >{{ item.title }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="基地类别" prop="baseType">
          <a-select v-model="form.baseType">
            <a-select-option
              :value="item.text"
              v-for="item in jdxslist"
              :key="item.text"
              >{{ item.title }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="加入时间" prop="cooperativeTime">
          <a-date-picker
            placeholder="请选择加入时间"
            v-model="form.cooperativeTime"
            :format="'YYYY-MM-DD'"
            :locale="locale"
            class="form-item-right"
          />
        </a-form-model-item>
        <a-form-model-item label="合作单位" prop="company">
          <div class="flex">
            <a-select v-model="form.company">
              <a-select-option
                :value="item.text"
                v-for="item in hzdwlist"
                :key="item.text"
                >{{ item.title }}</a-select-option
              >
              <!-- <a-select-option value="其他" >{{
                item.title
              }}</a-select-option> -->
            </a-select>
            <template v-if="form.company == '其他'">
              <a-input v-model="form.otherCompany" class="ipt-other" />
            </template>
          </div>
        </a-form-model-item>
        <a-form-model-item label="育人功能关键词" prop="keyWords1">
          <a-select
            mode="tags"
            style="width: 100%"
            v-model="form.keyWords1"
            placeholder="请选择育人功能关键词"
            @change="handleChangezh"
          >
            <a-select-option v-for="item in kcList" :value="item.name">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="活动年份" prop="acquireYear">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.acquireYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
          />
        </a-form-model-item>
        <a-form-model-item label="活动主题" prop="subject">
          <a-input v-model="form.subject" placeholder="请输入活动主题" />
        </a-form-model-item>
        <a-form-model-item label="参与人数" prop="peopleNum">
          <a-input-number v-model="form.peopleNum" min="1" precision="0" />
        </a-form-model-item>
        <a-form-model-item label="地点" prop="address">
          <a-input v-model="form.address" placeholder="请输入地点" />
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>
    
<script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        // applyId: "",
        baseName: "",
        baseForm: "",
        baseType: "",
        cooperativeTime: "",
        acquireYear: "",
        peopleNum: "",
      },
      rules: {
        baseName: [
          {
            required: true,
            message: "请输入基地名称",
            trigger: "blur",
          },
        ],
        baseForm: [
          {
            required: true,
            message: "请选择基地形式",
            trigger: "change",
          },
        ],
        baseType: [
          {
            required: true,
            message: "请选择基地类别",
            trigger: "change",
          },
        ],
        cooperativeTime: [
          {
            required: true,
            message: "请选择加入时间",
            trigger: "blur",
          },
        ],
        company: [
          {
            required: true,
            message: "请选择合作单位",
            //          type: 'string',
            trigger: "change",
          },
        ],
        keyWords1: [
          {
            required: true,
            message: "请选择育人功能关键词",
            trigger: "change",
          },
        ],
        acquireYear: [
          {
            validator: (rule, value, callback) => {
              if (this.form.acquireYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择年份"));
              }
            },
            required: true,
            message: "请选择年份",
            trigger: "change",
          },
        ],
        subject: [
          {
            required: true,
            message: "请输入活动主题",
            trigger: "blur",
          },
        ],
        peopleNum: [
          {
            required: true,
            message: "请输入参与人数",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入地点",
            trigger: "blur",
          },
        ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 1,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      jdxslist: [],
      jdlb: [],
      ishow: false,
      ifirst: true,
      hzdwlist: [],
      kcList: [],
    };
  },
  components: { BaseEditor },
  mounted() {
    // console.log("111111");
    // console.log(this.rules);
  },
  methods: {
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      this.form.acquireYear = value;
      this.$refs.ruleForm.clearValidate("acquireYear");
      this.yearShowOne = false;
    },
    getkcList() {
      getAction("/lxbase/lxFuncKeywords/allList", {}).then((res) => {
        console.log(res, "66666");
        if (res.code == 200) {
          console.log(res, "66666");
          this.kcList = res.result;
        }
      });
    },
    gethzdwlist() {
      getAction("/baseCommon/getDictItemsByCode?code=sz_company").then(
        (res) => {
          if (res.code == 200) {
            this.hzdwlist = res.result;
          }
        }
      );
    },
    handleChangezh() {
      if (this.form.keyWords1.length > 0) {
        let keyWords1 = this.form.keyWords1;
        this.form.keyWords = keyWords1.join(",");
      } else {
        this.form.keyWords = "";
      }
    },
    async init(type, record) {
      this.type = type;
      this.visible = true;

      // 先加载下拉列表数据
      await Promise.all([
        this.getjdxslist(),
        this.getjdlblist(),
        this.gethzdwlist(),
        this.getkcList(),
      ]);

      if (type == "add") {
        this.form = {
          keyWords1: [], // 确保有初始值
        };
        this.title = "新增基地";
      } else {
        this.title = "编辑基地";

        // 确保 keyWords1 有默认值
        let keyWords1 = [];
        if (record.keyWords && record.keyWords !== "") {
          keyWords1 = record.keyWords.split(",");
        }

        this.form = {
          peopleNum: record.peopleNum,
          acquireYear: record.acquireYear,
          id: record.id,
          cooperativeTime: record.cooperativeTime,
          baseForm: record.baseForm,
          baseType: record.baseType,
          baseName: record.baseName,
          company: record.company,
          otherCompany: record.otherCompany,
          keyWords: record.keyWords,
          keyWords1: keyWords1, // 确保赋值
          subject: record.subject,
          address: record.address,
        };
      }
    },
    handleCancel() {
      this.visible = false;
    },
    getjdxslist(ids) {
      getAction("/baseCommon/getDictItemsByCode?code=base_type").then((res) => {
        if (res.code == 200) {
          this.jdxslist = res.result;
        }
      });
    },
    getjdlblist() {
      getAction("/baseCommon/getDictItemsByCode?code=base_form").then((res) => {
        if (res.code == 200) {
          this.jdlblist = res.result;
        }
      });
    },
    submit() {
      if (
        typeof this.form.acquireYear == "object" &&
        this.form.acquireYear != ""
      ) {
        this.form.acquireYear =
          new Date(this.form.acquireYear).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        console.log(valid);
        if (valid) {
          let formattedDate = "";
          if (
            typeof this.form.cooperativeTime == "object" &&
            this.form.cooperativeTime != ""
          ) {
            const dateObj = new Date(this.form.cooperativeTime);
            const year = dateObj.getFullYear();
            const month = dateObj.getMonth() + 1; // 月份是从 0 开始的，所以要加 1
            const date = dateObj.getDate();
            formattedDate = `${year}-${month.toString().padStart(2, "0")}-${date
              .toString()
              .padStart(2, "0")}`;
            this.form.cooperativeTime = formattedDate;
          }

          if (this.type == "add") {
            let params = this.form;

            this.visible = false;
            this.$message.success("添加成功");
            this.$emit("addBase", { record: params, type: "add" });
            // params.applyType = this.applyType;
            // postAction("/lxbase/lxApplyCooperativeBase/add", params).then(
            //   (res) => {
            //     if (res.code == 200) {
            //       this.visible = false;
            //       this.$message.success("添加成功");
            //       this.$emit("addBase");
            //     } else {
            //       this.$message.error(res.message);
            //     }
            //   }
            // );
          } else {
            let params = this.form;
            if (typeof this.form.acquireYear == "object") {
              params.acquireYear =
                new Date(this.form.acquireYear).getFullYear() + "";
            }
            this.visible = false;
            this.$message.success("编辑成功");
            console.log(params, "1111");
            this.$emit("addBase", { record: params, type: "edit" });
            // params.applyType = this.applyType;
            // putAction("/lxbase/lxApplyCooperativeBase/edit", params).then(
            //   (res) => {
            //     if (res.code == 200) {
            //       this.visible = false;
            //       this.$message.success("编辑成功");
            //       this.$emit("addBase");
            //     } else {
            //       this.$message.error(res.message);
            //     }
            //   }
            // );
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>
  